// extracted by mini-css-extract-plugin
module.exports = {"container-guide":"game-guide_container-guide__21lVg","guide-iframe":"game-guide_guide-iframe__nb2-r","guide-loading":"game-guide_guide-loading__2cjUq"};